<template>
  <v-app-bar
    app
    clipped-left
    :color="color"
    dark
    dense
    fixed
    flat
  >
    <v-btn
      v-if="navigationLink"
      icon
      depressed
      tile
      :ripple="false"
      @click.stop="$emit('showNavigation')"
    >
      <v-icon>
        {{ mdiMenu }}
      </v-icon>
    </v-btn>

    <v-btn
      v-if="homeLink"
      depressed
      icon
      tile
      exact
      exact-active-class="disable-highlight"
      class="mr-3"
      :ripple="false"
      :to="{ path: '/' }"
    >
      <v-icon>
        {{ mdiHome }}
      </v-icon>
    </v-btn>

    <v-icon
      v-if="!homeLink"
      class="mr-3"
    >
      {{ mdiTextBox }}
    </v-icon>

    <v-toolbar-title class="d-flex">
      <div>{{ orgName }} - {{ appName }}</div>
      <Breadcrumbs v-if="!title" />
      <div v-else>
        <v-icon
          class="mx-3"
        >
          {{ mdiArrowRight }}
        </v-icon>
        {{ title }}
      </div>
      <!-- <portal-target name="navigationBarTitle" /> -->
    </v-toolbar-title>
    <v-spacer />
    <UserMenu />
  </v-app-bar>
</template>

<style>
.disable-highlight::before{
  background-color: transparent !important;
  opacity:0 !important;
  transition-duration:0 !important;
}
</style>

<script>
import {
  mdiMenu,
  mdiHome,
  mdiTextBox,
  mdiArrowRight
} from "@mdi/js"

import UserMenu from './user-menu'
import Breadcrumbs from './breadcrumbs'

export default {
  components: { Breadcrumbs, UserMenu },
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    navigationLink: {
      type: Boolean,
      default: false
    },
    homeLink: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      value: null
    }
  },
  data: () => ({
    mdiMenu,
    mdiHome,
    mdiTextBox,
    mdiArrowRight
  }),
  computed: {
    appName () {
      return this.$store.state.appName
    },
    orgName () {
      return this.$store.state.orgName
    }
  }
}
</script>
